const cart = {
  descEmpty: 'Ihr Warenkorb ist leer',
  tipDelete: 'löschen',
  table: {
    headings: {
      position: 'Pos.',
      article: 'Artikel',
      quantity: 'Anzahl',
      unitPrice: 'Stückpreis',
      sumPrice: 'Summe'
    },
    article: {
      form: 'Form',
      size: 'Maße',
      material: 'Material',
      color: 'Farbe',
      rand: 'Rand',
      note: 'Hinweis'
    }
  },
  summary: {
    sum: 'Summe',
    vatBefore: '(inkl.',
    vatAfter: 'MwSt.)'
  }
}

export default {
  cart
}
